import {PewComponent} from "../../../assets/raw/js/components/pew-component";

export class ManifestComponent extends PewComponent {
    constructor(element, options) {
        let defaultOptions = {
        };

        super(element, Object.assign(defaultOptions, options));
    }
    init() {
        this.registerEvents();
    }
    registerEvents(){
        this.registerArrowClick();
        this.registerOpenPanel();
        this.registerClosePanel();
    }
    registerArrowClick() {
        var self = this;

        this.element.find('a.prev').on('click', (e) => {

            let $manifestToShow = e.currentTarget.href;
            var $splitHref = $manifestToShow.split("#");
            let $idManifest = $splitHref[1];

            $(".manifest-item").each(function(index, item){
                $(item).removeClass("active");
                if($(item).attr("id") == $idManifest){
                    $(item).addClass("active");
                }
            });

        });

        this.element.find('a.next').on('click', (e) => {

            let $manifestToShow = e.currentTarget.href;
            var $splitHref = $manifestToShow.split("#");
            let $idManifest = $splitHref[1];

            $(".manifest-item").each(function(index, item){
                $(item).removeClass("active");
                if($(item).attr("id") == $idManifest){
                    $(item).addClass("active");
                }
            });

        });
    }
    registerOpenPanel(){
        var self = this;
        this.element.find('a.manifest-trigger').on('click', (e) => {
           let $button = e.currentTarget;
            $($button).parent().parent().find("#manifest-target").addClass('active');
        });
    }
    registerClosePanel(){
        var self = this;
        this.element.find("button.drawer-close").on('click', (e) => {
           let $button = e.currentTarget;
           $($button).parent().removeClass('active');
        });
    }
}

window.pew.addRegistryEntry({key: 'wdf-manifest', domSelector: '.section-manifeste', classDef: ManifestComponent});



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/Manifest/ManifestComponent.js